import { render } from "./ClientView.vue?vue&type=template&id=68dfbdbb&scoped=true&ts=true"
import script from "./ClientView.vue?vue&type=script&lang=ts"
export * from "./ClientView.vue?vue&type=script&lang=ts"

import "./ClientView.vue?vue&type=style&index=0&id=68dfbdbb&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68dfbdbb"]])

export default __exports__